import { instance } from "libs/api";

import { ApiRoutesMarketing } from "../../constants";
import {
  MarketingFlow,
  UpdateMarketingFlowPayload
} from "../../marketing.types";

export const requestUpdateMarketingFlow = async ({
  flowId,
  data
}: UpdateMarketingFlowPayload): Promise<MarketingFlow> => {
  return await instance.patch(`${ApiRoutesMarketing.Flows}/${flowId}`, data);
};
